import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Spin,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  getAboutLot,
  getCheckHeveGetNew,
  getCurrentDateUtilYYYY,
  getDateUtilYYYYBydate,
  getLotResults,
  getLotTotalDataApi,
  getOrders,
  getOrdersV2,
  getOrdersV3,
  getRmNumday,
  getToken,
  isAdmin,
  newDateUtil,
  numberWithCommas,
  reflectorLotTypes_2_version2,
  reflectorLots_2_version3,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import LotTable from "../lotTable/LotTable";
import {
  LoadingOutlined,
  SearchOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import LoadingCenter from "./LoadingCenter";
import LotTableV2 from "../lotTable/LotTableV2";
import LoadingCenterContent from "./LoadingCenterContent";
import dayjs from "dayjs";
import Countdown from "react-countdown";
const { RangePicker } = DatePicker;

function SummaryV2(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

function Content(props) {
  const appContext = useContext(AppContext);
  const [lots, setLots] = useState([]);
  const [orders, setOrders] = useState([]);
  const [lotResualts, setLotResualts] = useState([]);
  const [lotTypes, setLotTypes] = useState([]);
  const [selectMonth, setSelectMonth] = useState("");
  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");
  const [searchType, setSearchType] = useState("today");
  const [loading, setLoading] = useState(false);
  const [isTop5, setIsTop5] = useState("Y");

  const [isAdminMain, setIsAdminMain] = useState(false);
  const loaderData = async () => {
    // let havegetnew = await getCheckHeveGetNew();
    let havegetnew = false;
    let aboutLot = null;
    if (!checkEmpty(localStorage.getItem("aboutLot")) && havegetnew == false) {
      aboutLot = JSON.parse(localStorage.getItem("aboutLot"));
    } else {
      try {
        aboutLot = await getAboutLot();
        localStorage.setItem("aboutLot", JSON.stringify(aboutLot));
        console.log("aboutLot", aboutLot);
      } catch (e) {}
    }

    // let datefrom = getCurrentDateUtilYYYY();
    // let dateto = getCurrentDateUtilYYYY();
    var curr = newDateUtil();
    curr.setDate(curr.getDate() + 30);
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getDateUtilYYYYBydate(curr);
    setLoading(true);
    // try {
    //   let datas = await getLotResults(datefrom, dateto);
    //   setLotResualts(datas);
    // } catch (e) {}

    // let ordersRes = [];
    let orderTemp = [];
    let lots = reflectorLots_2_version3(aboutLot.lots);
    try {
      console.log("appContext.acUsername", appContext.acUsername);
      let data = await getOrdersV3(
        datefrom,
        dateto,
        appContext.acUsername,
        isTop5
      );
      setLoading(false);
      setLotResualts(data.lotResualts);
      setOrders(data.orders);
      orderTemp = data.orders;
    } catch (e) {
      setLoading(false);
    }
    // setLotTypes(
    //   reflectorLotTypes_2_version2(aboutLot.lotTypes, aboutLot.lots, ordersRes)
    // ); //(aboutLot.lotTypes);
    // setLots(Object.assign([], reflectorLots_2_version3(aboutLot.lots)));
    setLots(Object.assign([], lots));

    getLotTotalData(datefrom, dateto, orderTemp, false);
  };

  useEffect(() => {
    // console.log("useEffect");
    loaderData();
    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        setIsAdminMain(true);
      } else {
        setIsAdminMain(false);
      }
    }
  }, []);

  const getDateFromTo = () => {
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getCurrentDateUtilYYYY();
    if (searchType == "today") {
      var curr = newDateUtil();
      curr.setDate(curr.getDate() + 30);
      datefrom = getCurrentDateUtilYYYY();
      dateto = getDateUtilYYYYBydate(curr);
    } else if (searchType == "yesterday") {
      var date = newDateUtil();
      date.setDate(date.getDate() - 1);
      let dateStr = getDateUtilYYYYBydate(date);
      datefrom = dateStr;
      dateto = dateStr;
    } else if (searchType == "this_week") {
      var curr = newDateUtil(); // get current date
      let day = curr.getDay();
      let rmnumday = getRmNumday(day);
      let firstD = newDateUtil();
      firstD.setDate(firstD.getDate() - rmnumday);
      let lastD = newDateUtil();
      lastD.setDate(lastD.getDate() - rmnumday + 6);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "old_week") {
      var curr = newDateUtil(); // get current date
      let day = curr.getDay();
      let rmnumday = getRmNumday(day);
      let firstD = newDateUtil();
      firstD.setDate(firstD.getDate() - rmnumday - 7);
      let lastD = newDateUtil();
      lastD.setDate(lastD.getDate() - rmnumday - 7 + 6);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "month") {
      var month = selectMonth - 1;
      var firstD = new Date(newDateUtil().getFullYear(), month, 1);
      var lastD = new Date(newDateUtil().getFullYear(), month + 1, 0);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "date_from_to") {
      datefrom = selectDateFrom;
      if (checkEmpty(selectDateTo)) {
        setSelectDateTo(selectDateFrom);
        dateto = selectDateFrom;
      } else {
        dateto = datefrom;
        dateto = selectDateTo;
      }
    }
    return { dateto: dateto, datefrom: datefrom };
  };

  const searchAction = async () => {
    let d = getDateFromTo();
    let datefrom = d.datefrom;
    let dateto = d.dateto;

    let orderTemp = [];
    try {
      setLoading(true);
      let data = await getOrdersV3(
        datefrom,
        dateto,
        appContext.acUsername,
        isTop5
      );
      setLotResualts(Object.assign([], data.lotResualts));
      setOrders(Object.assign([], data.orders));
      orderTemp = data.orders;
      // setLotTypes(
      //   Object.assign(
      //     [],
      //     reflectorLotTypes_2_version2(lotTypes, lots, ordersRes)
      //   )
      // );
      setLots(Object.assign([], reflectorLots_2_version3(lots)));
      setLoading(false);
    } catch (e) {}

    getLotTotalData(datefrom, dateto, orderTemp, false);
  };

  const [lotTotalData, setLotTotalData] = useState(null);
  const [lotTotalDataLoading, setLotTotalDataLoading] = useState(null);

  const getLotTotalData = async (
    datefrom,
    dateto,
    ordersTemp,
    isLoadInterval
  ) => {
    if (isTop5 == "Y" || isLoadInterval) {
      if (isLoadInterval == false) setLotTotalDataLoading(true);
      if (isLoadInterval) setAutoLoading(true);
      if (searchType == "today") {
        dateto = datefrom;
      }
      try {
        let datas = await getLotTotalDataApi(
          datefrom,
          dateto,
          appContext.acUsername
        );

        let datatemp = datas.filter((o) => o.status != "N");
        let sumPriceTemp = 0;
        let sumPayDone = 0;
        for (let a = 0; a < datatemp?.length; a++) {
          sumPriceTemp += parseInt(datatemp[a].total_price_multi);
          sumPayDone += parseInt(datatemp[a].done_price);
        }
        let data = { lot_price: sumPriceTemp, done_price: sumPayDone };
        setLotTotalData(Object.assign({}, data));
        setLotTotalDataLoading(false);
        if (isLoadInterval) setAutoLoading(false);
        // console.log("data", data);
      } catch (e) {
        setLotTotalDataLoading(false);
        if (isLoadInterval) setAutoLoading(false);
      }
    } else {
      let sumPriceTemp = 0;
      let sumPayDone = 0;
      for (let a = 0; a < ordersTemp?.length; a++) {
        if (ordersTemp[a].status == "N") {
          continue;
        }
        if (searchType == "today") {
          let d = getDateUtilYYYYBydate(newDateUtil(ordersTemp[a].lot_date));
          // console.log(
          //   "date : " + (d != datefrom) + " : " + d + " : " + datefrom
          // );
          if (d != datefrom) continue;
        }
        sumPriceTemp = sumPriceTemp + parseInt(ordersTemp[a].total_price_multi);
        sumPayDone += parseInt(ordersTemp[a].done_price);
      }

      let data = { lot_price: sumPriceTemp, done_price: sumPayDone };
      // console.log("data", data);
      setLotTotalData(Object.assign({}, data));
    }
  };

  const getLotAndOrder = useMemo(() => {
    let lotsUse = [];

    for (let b = 0; b < lots.length; b++) {
      let ordersUse = [];
      let last_order = null;
      for (let a = 0; a < orders.length; a++) {
        if (orders[a].lot_id == lots[b].lot_id) {
          if (a == 0) last_order = orders[a].last_order;
          ordersUse.push(orders[a]);
        }
      }
      if (ordersUse.length > 0) {
        let lotuse = lots[b];
        lotuse.last_order = last_order;
        lotuse.orders = ordersUse;
        lotsUse.push(lotuse);
      }
    }

    // console.log("lotsUse", lotsUse);
    lotsUse.sort(function (a, b) {
      var keyA = newDateUtil(a.last_order),
        keyB = newDateUtil(b.last_order);
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
    return lotsUse;
  }, [lots]);

  const getSumPriceTotal = useMemo(() => {
    if (lotTotalData == null) return;
    let sum =
      parseInt(lotTotalData.lot_price) - parseInt(lotTotalData.done_price);
    let color = "green";
    if (sum < 0) {
      color = "red";
    }

    return (
      <span>
        <span style={{ paddingLeft: "5px", color: color }}>
          ({numberWithCommas(sum)})
        </span>
      </span>
    );
  }, [lotTotalData]);

  const getSumPriceTotalLot = useMemo(() => {
    if (lotTotalData == null) return;
    let sum = parseInt(lotTotalData.lot_price); //- parseInt(lotTotalData.done_price);
    let color = "green";

    return (
      <span>
        <span style={{ paddingLeft: "5px", color: color }}>
          ({numberWithCommas(sum)})
        </span>
      </span>
    );
  }, [lotTotalData]);
  const getSumPriceTotalDone = useMemo(() => {
    if (lotTotalData == null) return;
    let sum = parseInt(lotTotalData.done_price); //- parseInt(lotTotalData.done_price);
    let color = "red";

    return (
      <span>
        <span style={{ paddingLeft: "5px", color: color }}>
          ({numberWithCommas(sum)})
        </span>
      </span>
    );
  }, [lotTotalData]);

  const [loadTotalIntervalMain, setLoadTotalIntervalMain] = useState(null);
  const [loadOrderIntervalMain, setLoadOrderIntervalMain] = useState(null);
  const [autoLoad, setAutoLoad] = useState(false);
  const [autoLoading, setAutoLoading] = useState(false);
  const [autoLoadingInterval, setAutoLoadingInterval] = useState(false);

  const loadOrder = async () => {
    let d = getDateFromTo();
    let datefrom = d.datefrom;
    let dateto = d.dateto;
    let data = await getOrdersV3(
      datefrom,
      dateto,
      appContext.acUsername,
      isTop5
    );
    setLoading(true);
    setLotResualts(Object.assign([], data.lotResualts));
    setLotResualts(Object.assign([], []));
    setOrders(Object.assign([], []));
    setOrders(Object.assign([], data.orders));
    setLots(Object.assign([], []));
    setLots(Object.assign([], reflectorLots_2_version3(lots)));
    console.log("loadOrder");
    setInterval(function () {
      setLoading(false);
    }, 200);
  };

  useEffect(() => {
    if (autoLoad) {
      try {
        let loadOrderInterval = setInterval(function () {
          loadOrder();
        }, 15000);
        setLoadOrderIntervalMain(loadOrderInterval);
        let loadTotalInterval = setInterval(function () {
          let d = getDateFromTo();
          let datefrom = d.datefrom;
          let dateto = d.dateto;
          let orderTemp = [];
          getLotTotalData(datefrom, dateto, orderTemp, true);
        }, 15000);
        setLoadTotalIntervalMain(loadTotalInterval);
      } catch (e) {}
    } else {
      if (!checkEmpty(loadOrderIntervalMain)) {
        clearInterval(loadOrderIntervalMain);
      }
      if (!checkEmpty(loadTotalIntervalMain)) {
        clearInterval(loadTotalIntervalMain);
      }
    }
  }, [autoLoad]);

  return (
    <>
      <div className={styles.box100}>
        {isAdminMain && (
          <div style={{ padding: "10px" }} className={styles.headerSetResualt}>
            กำลังดูของ : {appContext.acUsername}
          </div>
        )}

        <div className={styles.boxSearch}>
          <div
            style={{ width: "80px" }}
            className={isTop5 == "Y" ? styles.searchTypeAc : styles.searchType}
            onClick={() => {
              let use = isTop5;
              if (use == "N") {
                use = "Y";
              } else if (use == "Y") {
                use = "N";
              }
              setIsTop5(use);
            }}
          >
            ล่าสุด 5 หวย
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "today" ? styles.searchTypeAc : styles.searchType
              }
              onClick={() => {
                setSearchType("today");
              }}
            >
              วันนี้
            </div>
            <div
              className={
                searchType == "yesterday"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("yesterday");
              }}
            >
              เมื่อวาน
            </div>
            <div
              className={
                searchType == "this_week"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("this_week");
              }}
            >
              สัปดาห์นี้
            </div>
            <div
              className={
                searchType == "old_week"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("old_week");
              }}
            >
              สัปดาห์ที่แล้ว
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "month" ? styles.searchTypeAc : styles.searchType
              }
              onClick={() => {
                setSearchType("month");
              }}
            >
              เดือน
            </div>
            <div className={styles.selectMont}>
              {" "}
              <Select
                // showSearch
                className={styles.selectMountSearch}
                style={{ width: 200 }}
                placeholder="เลือกเดือน"
                optionFilterProp="children"
                // filterOption={(input, option) =>
                //   (option?.label ?? "").includes(input)
                // }
                // filterSort={(optionA, optionB) =>
                //   (optionA?.label ?? "")
                //     .toLowerCase()
                //     .localeCompare((optionB?.label ?? "").toLowerCase())
                // }
                onChange={(v) => {
                  setSearchType("month");
                  setSelectMonth(v);
                }}
                options={[
                  {
                    value: "1",
                    label: "มกราคม",
                  },
                  {
                    value: "2",
                    label: "กุมภาพันธ์",
                  },
                  {
                    value: "3",
                    label: "มีนาคม ",
                  },
                  {
                    value: "4",
                    label: "เมษายน",
                  },
                  {
                    value: "5",
                    label: "พฤษภาคม",
                  },
                  {
                    value: "6",
                    label: "มิถุนายน",
                  },
                  {
                    value: "7",
                    label: "กรกฎาคม",
                  },
                  {
                    value: "8",
                    label: "สิงหาคม",
                  },
                  {
                    value: "9",
                    label: "กันยายน",
                  },
                  {
                    value: "10",
                    label: "ตุลาคม",
                  },
                  {
                    value: "11",
                    label: "พฤศจิกายน",
                  },
                  {
                    value: "12",
                    label: "ธันวาคม",
                  },
                ]}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "date_from_to"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("date_from_to");
              }}
            >
              ตั้งแต่วันที่
            </div>
            <div className={styles.selectDateFomTo}>
              {/* <RangePicker
                onChange={(dates, dateStrings) => {
                  console.log("dateStrings", dateStrings);
                  if (!checkEmpty(dateStrings[0])) {
                    // let dateF = getDateUtilYYYYBydate(dateStrings[0]);
                    // console.log(dateF);
                    setSelectDateFrom(dateStrings[0]);
                  }
                  if (!checkEmpty(dateStrings[1])) {
                    // let dateT = getDateUtilYYYYBydate(dateStrings[1]);
                    setSelectDateTo(dateStrings[1]);
                  }
                }}
              /> */}
              <DatePicker
                value={
                  checkEmpty(selectDateFrom)
                    ? ""
                    : dayjs(selectDateFrom, "YYYY-MM-DD")
                }
                className={styles.datefromtoSearch}
                placeholder="ตั้งเเต่วันที่"
                onChange={(dates, dateString) => {
                  console.log("dateString", dateString);
                  setSearchType("date_from_to");
                  setSelectDateFrom(dateString);
                  if (checkEmpty(selectDateTo)) setSelectDateTo(dateString);
                }}
              />
              <span className={styles.datefromto}>ถึง</span>
              <DatePicker
                value={
                  checkEmpty(selectDateTo)
                    ? ""
                    : dayjs(selectDateTo, "YYYY-MM-DD")
                }
                className={styles.datefromtoSearch}
                placeholder="ถึงวันที่"
                onChange={(dates, dateString) => {
                  console.log("dateString", dateString);
                  setSearchType("date_from_to");
                  setSelectDateTo(dateString);
                }}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <Button
              className={styles.btnSearchSum}
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {
                searchAction();
              }}
            >
              ค้นหา
            </Button>
            <div style={{ paddingLeft: "15px" }}>
              <Button
                className={styles.btnSearchSum}
                onClick={() => {
                  if (autoLoad) {
                    setAutoLoad(false);
                  } else {
                    setAutoLoad(true);
                  }
                }}
              >
                Auto Load :
                <span style={{ paddingLeft: "3px" }}>
                  {autoLoad ? "Y" : "N"}
                  {autoLoading ? (
                    <span style={{ paddingLeft: "5px", width: "15px" }}>
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ fontSize: 15 }} spin />
                        }
                      />
                    </span>
                  ) : (
                    <span style={{ paddingLeft: "5px", width: "15px" }}>
                      <ClockCircleOutlined style={{ fontSize: 15 }} />
                    </span>
                  )}
                </span>
              </Button>
            </div>
          </div>
        </div>
        <div>
          {loading ? (
            <LoadingCenterContent />
          ) : (
            <>
              <div>
                {/* <div className={styles.headerType}>{type.lot_type}</div> */}
                <div className={styles.boxLotMain}>
                  <div className={styles.boxLotMainTotal}>
                    <div className={styles.textHeaderSummary}>
                      ยอดซื้อ :{" "}
                      {lotTotalDataLoading ? (
                        <span
                          style={{ paddingLeft: "15px", paddingRight: "15px" }}
                        >
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: 15 }} spin />
                            }
                          />
                        </span>
                      ) : (
                        getSumPriceTotalLot
                      )}
                    </div>
                    <div className={styles.textHeaderSummary}>
                      ถูกรางวัล :{" "}
                      {lotTotalDataLoading ? (
                        <span
                          style={{ paddingLeft: "15px", paddingRight: "15px" }}
                        >
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: 15 }} spin />
                            }
                          />
                        </span>
                      ) : (
                        getSumPriceTotalDone
                      )}
                    </div>
                    <div className={styles.textHeaderSummary}>
                      ผลลัพธ์ :{" "}
                      {lotTotalDataLoading ? (
                        <span
                          style={{ paddingLeft: "15px", paddingRight: "15px" }}
                        >
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: 15 }} spin />
                            }
                          />
                        </span>
                      ) : (
                        getSumPriceTotal
                      )}
                    </div>
                  </div>

                  {getLotAndOrder.map((lot, index) => {
                    return (
                      // <div className={styles.boxLotItem}>{lot.lot_name}</div>
                      <LotTableV2
                        key={"LotTableV2_" + lot.name}
                        lot={lot}
                        orders={lot.orders}
                        // type={type}
                        lotResualts={lotResualts}
                        index={index}
                      ></LotTableV2>
                    );
                  })}
                  {orders.length == 0 && (
                    <div className={styles.boxnodata}>
                      <div className={styles.nodata}>No data</div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        <div
          style={{ paddingBottom: "50px", paddingTop: "50px" }}
          className={styles.backToTopDiv}
        >
          <Button
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            className={styles.backToTop}
          >
            Back To Top
          </Button>
        </div>
      </div>
    </>
  );
}
export default SummaryV2;
